import React from 'react';

import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import { Color } from '../../../Enum/Color';
import reduceScopesToColor from '../../../Reducer/ReduceScopesToColor';
import ScopeDetails from './ScopeDetails';
import ScopeResult from '../ScopeResult';

import useValidatorResult from '../../../Hook/Validator/UseValidatorResult';

interface Props {
    scopeName: string;
}

const ScopeRow: React.FC<Props> = Props => {
    const { scopeName } = Props;

    const validatorResult = useValidatorResult(scopeName);
    if (null === validatorResult) {
        return null;
    }

    const { acceptanceFeatureRules } = validatorResult;
    const color = reduceScopesToColor(acceptanceFeatureRules);

    return (
        <Card className={`features-row ${color}`}>
            <Accordion.Toggle as={Card.Header} eventKey={scopeName}>
                <Container fluid>
                    <Row>
                        <Col>{scopeName}</Col>
                        <ScopeResult color={Color.Green} rules={acceptanceFeatureRules} />
                        <ScopeResult color={Color.Orange} rules={acceptanceFeatureRules} />
                        <ScopeResult color={Color.Red} rules={acceptanceFeatureRules} />
                        <ScopeResult color={Color.Blue} rules={acceptanceFeatureRules} />
                    </Row>
                </Container>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey={scopeName}>
                <Card.Body>
                    <ScopeDetails scope={acceptanceFeatureRules} />
                </Card.Body>
            </Accordion.Collapse>
        </Card>
    );
};

export default ScopeRow;
